import './trending-bottom-card.scss'

import React from 'react'

import Card from '@/components/card/card'

const config = {
  className: 'trending-bottom-card',
  minicard: true,
  hasNoImage: false,
  hasUnderline: false,
  hasNoLocationDisplay: true,
  isSearch: false,
  isCarousel: false,
}

export const TrendingBottomCard = ({ item, ...restProps }) => (
  <Card item={item} {...restProps} {...config} />
)
